export const normalizeThemeOpenButtonBottomCss = (value) => {
  if (value == null) {
    return null;
  }

  const trimmedValue = String(value).trim();
  if (trimmedValue === "" || trimmedValue === "0") {
    return null;
  }

  return trimmedValue;
};
